import QuoteForm from '@/components/feature/QuoteForm';

export default function ContactSection() {
  return (
    <section id="contact-form" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-14">

          {/* ── Left column: Contact Details ── */}
          <div className="lg:col-span-2 space-y-8">
            <div>
              <h2 className="text-3xl font-extrabold text-gray-900 mb-2">Contact Details</h2>
              <p className="text-gray-500 text-sm">
                Reach out directly or fill in the form and we&apos;ll get back to you within 24 hours.
              </p>
            </div>

            {/* Phone */}
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-teal-50 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-phone-line text-2xl text-teal-400"></i>
              </div>
              <div>
                <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">Phone</p>
                <a
                  href="tel:+16563477380"
                  className="text-gray-900 font-bold text-base hover:text-teal-500 transition-colors"
                >
                  +1 656-347-7380
                </a>
                <p className="text-xs text-gray-400 mt-0.5">Mon–Fri: 8:00 AM – 5:00 PM</p>
              </div>
            </div>

            {/* Email */}
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-teal-50 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-2xl text-teal-400"></i>
              </div>
              <div>
                <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">Email</p>
                <a
                  href="mailto:info@popprotents.com"
                  className="text-gray-900 font-bold text-base hover:text-teal-500 transition-colors"
                >
                  info@popprotents.com
                </a>
              </div>
            </div>

            {/* Follow Us */}
            <div>
              <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Follow Us</p>
              <div className="flex gap-3">
                <a
                  href="https://www.facebook.com/popprotents/"
                  target="_blank"
                  rel="nofollow"
                  className="w-11 h-11 bg-gray-100 hover:bg-teal-400 rounded-xl flex items-center justify-center transition-colors group cursor-pointer"
                >
                  <i className="ri-facebook-fill text-xl text-gray-500 group-hover:text-white"></i>
                </a>
                <a
                  href="https://www.instagram.com/popprotents"
                  target="_blank"
                  rel="nofollow"
                  className="w-11 h-11 bg-gray-100 hover:bg-teal-400 rounded-xl flex items-center justify-center transition-colors group cursor-pointer"
                >
                  <i className="ri-instagram-line text-xl text-gray-500 group-hover:text-white"></i>
                </a>
                <a
                  href="https://www.linkedin.com/company/popprotents"
                  target="_blank"
                  rel="nofollow"
                  className="w-11 h-11 bg-gray-100 hover:bg-teal-400 rounded-xl flex items-center justify-center transition-colors group cursor-pointer"
                >
                  <i className="ri-linkedin-fill text-xl text-gray-500 group-hover:text-white"></i>
                </a>
              </div>
            </div>
          </div>

          {/* ── Right column: Inquire Now form ── */}
          <div className="lg:col-span-3 bg-gray-50 rounded-2xl p-8">
            <h2 className="text-2xl font-extrabold text-gray-900 mb-1">Inquire Now</h2>
            <p className="text-gray-500 text-sm mb-6">
              Tell us what you need — to rent for an event or to buy outright — and we&apos;ll reply within 24 hours.
            </p>
            <QuoteForm theme="light" />
          </div>
        </div>
      </div>
    </section>
  );
}
